import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: 'sumup/oauth/callback',
    loadComponent: () =>
      import(
        './user-settings/online-payment/sumup-callback/sumup-callback.component'
      ).then((m) => m.SumupCallbackComponent)
  },
  {
    path: ':uuid/thank-you',
    loadComponent: () =>
      import('./thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent
      )
  },
  {
    path: 'terms-conditions',
    loadComponent: () =>
      import('./terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent
      )
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./auth/register/register.component').then(
        (m) => m.RegisterComponent
      )
  },
  {
    path: 'activate-account',
    loadComponent: () =>
      import('./auth/activate-account/activate-account.component').then(
        (m) => m.ActivateAccountComponent
      )
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      )
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      )
  },
  {
    path: 'log-in',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'user-events/:uuid',
    loadChildren: () =>
      import('./sales/online-booking/online-booking.routes').then(
        (m) => m.ONLINE_BOOKING_ROUTES
      )
  },
  {
    path: 'online-booking-1/:uuid',
    loadChildren: () =>
      import('./sales/online-booking/online-booking.routes').then(
        (m) => m.ONLINE_BOOKING_ROUTES
      )
  },
  {
    path: 'online-booking/:uuid',
    loadChildren: () =>
      import('./sales/online-booking-2/online-booking-2.routes').then(
        (m) => m.ONLINE_BOOKING_2_ROUTES
      )
  },
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout.routes').then((m) => m.LAYOUT_ROUTES)
  },
  {
    path: 'test',
    loadChildren: () => import('./test/test.routes').then((m) => m.TEST_ROUTES)
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];

